// eslint-disable-next-line
import { getRouters } from '@/api/menu'
import { statusCount, reginCount } from '@/api/pressure/dispatch'

import { indexRouterMap } from '@/config/router.config'
import allIcon from '@/core/icons'
import { validURL } from '@/utils/validate'
import { UserLayout, BlankLayout, PageView } from '@/layouts'
import auth from '@/plugins/auth'
// 前端路由表
const constantRouterComponents = {
  // 基础页面 layout 必须引入
  BasicLayout: () => import('@/layouts/BasicLayout'),
  BlankLayout: BlankLayout,
  RouteView: () => import('@/layouts/RouteView'),
  PageView: PageView,
  UserLayout: UserLayout, // 登陆注册页面的通用布局

  // 你需要动态引入的页面组件
  'Index': () => import('@/views/index'),
  // account
  'AccountCenter': () => import('@/views/account/center'),
  'AccountSettings': () => import('@/views/account/settings'),
  // job log
  'JobLog': () => import('@/views/monitor/job/log'),
  // 授权用户
  'AuthUser': () => import('@/views/system/role/authUser'),
  // 公告新增修改
  'NoticeForm': () => import('@/views/system/notice/CreateForm'),
  // 商品列表新增修改
  'goodsForm': () => import('@/views/mall/goods/CreateForm'),
  // VR存储套餐购买页面
  'BuyNow': () => import('@/views/VR/storagePackage/BuyNow'),
  // VR流量分配页面
  'TrafficAllocation': () => import('@/views/VR/storagePackage/TrafficAllocation'),
  // VR存储仪表板页面
  'StorageDashboard': () => import('@/views/VR/storagePackage/StorageDashboard'),
  //
  'zrIndex': () => import('@/views/sms/channel/zrdata'),
  // 短信套餐包页面
  'SmsPackage': () => import('@/views/sms/package'),
  // 修改生成配置
  'GenEdit': () => import('@/views/tool/gen/modules/GenEdit'),
}

// 前端未找到页面路由（固定不用改）
const notFoundRouter = {
  path: '*', redirect: '/404', hidden: true,
}

// 根级菜单
const rootMenu = {
  key: '',
  name: 'index',
  path: '',
  component: 'BasicLayout',
  redirect: '/index',
  meta: {
    title: '首页',
  },
  children: [],
}

// 根级路由
const rootRouter = {
  key: '',
  name: 'index',
  path: '',
  component: constantRouterComponents.BasicLayout,
  redirect: '/index',
  meta: {
    title: '首页',
  },
  children: [],
}

/**
 * 动态生成菜单
 * @param token
 * @returns {Promise<Router>}
 */
export const generatorDynamicRouter = (token) => {
  return new Promise((resolve, reject) => {
    // 向后端请求路由数据
    getRouters().then(res => {
      // 路由菜单分离，路由全部为二级，解决多级菜单缓存问题
      const routers = []
      const menuNav = []
      const routerData = res.data || []

        /* ---------- 1. 空数组兜底 ---------- */
        if (!routerData.length) {
          console.warn('后端未返回任何菜单，走兜底静态路由')
          // 直接给首页，防止白屏
          routerData.push({
            name: 'Index',
            path: '/index',
            component: 'Index',
            meta: { title: '首页', icon: 'dashboard' },
          })
        }

      if (routerData && routerData.length) {
        routerData.forEach(v => {
          if (v.name == 'Dispatch') {
            statusCount().then(respon => {
              const date = respon.data
              v.children.forEach(item => {
                if (item.name == 'DispatchFive') {
                  // 待接单
                  item.meta.title = item.meta.title + '(' + date.pendingCount + ')'
                }
                if (item.name == 'DispatchThree') {
                  // 待派单
                  item.meta.title = item.meta.title + '(' + date.toBeSentCount + ')'
                }
                if (item.name == 'DispatchSix') {
                  // 待试压
                  item.meta.title = item.meta.title + '(' + date.toBePressedCount + ')'
                }
                if (item.name == 'DispatchSeven') {
                  // 待审核
                  item.meta.title = item.meta.title + '(' + date.submittedCount + ')'
                }
                if (item.name == 'Ten') {
                  // 已驳回
                  item.meta.title = item.meta.title + '(' + date.rejectedCount + ')'
                }
                if (item.name == 'DispatchFour') {
                  // 已拒绝
                  item.meta.title = item.meta.title + '(' + date.declinedCount + ')'
                }
                if (item.name == 'DispatchEight') {
                  // 已完成
                  item.meta.title = item.meta.title + '(' + date.completedCount + ')'
                }
                if (item.name == 'DispatchNine') {
                  // 已作废
                  item.meta.title = item.meta.title + '(' + date.haveBeenCancelledCount + ')'
                }
              })
            })
          }
          if (v.name == 'WorkOrder') {
            reginCount().then(respon => {
              const date = respon.data
              v.children.forEach(item => {
                if (item.name == 'WorkerFive') {
                  // 待接单
                  item.meta.title = item.meta.title + '(' + date.pendingCount + ')'
                }
                if (item.name == 'WorkerThree') {
                  // 待派单
                  item.meta.title = item.meta.title + '(' + date.toBeSentCount + ')'
                }
                if (item.name == 'WorkerSix') {
                  // 待试压
                  item.meta.title = item.meta.title + '(' + date.toBePressedCount + ')'
                }
                if (item.name == 'WorkerSeven') {
                  // 待审核
                  item.meta.title = item.meta.title + '(' + date.submittedCount + ')'
                }
                if (item.name == 'WorkerTen') {
                  // 已驳回
                  item.meta.title = item.meta.title + '(' + date.rejectedCount + ')'
                }
                if (item.name == 'WorkerFour') {
                  // 已拒绝
                  item.meta.title = item.meta.title + '(' + date.declinedCount + ')'
                }
                if (item.name == 'WorkerEight') {
                  // 已完成
                  item.meta.title = item.meta.title + '(' + date.completedCount + ')'
                }
                if (item.name == 'WorkerNine') {
                  // 已作废
                  item.meta.title = item.meta.title + '(' + date.haveBeenCancelledCount + ')'
                }
              })
            })
          }
        })
        setTimeout(() => {
          const asyncRoutes = filterDynamicRoutes(indexRouterMap)
          rootMenu.children = asyncRoutes.concat(routerData)
          menuNav.push(rootMenu)
          const menus = generator(menuNav, null, routers)
          menus.push(notFoundRouter)
          rootRouter.children = routers
          resolve({ menus, routers: rootRouter })
        }, 2000)
      }
    }).catch(err => {
      reject(err)
    })
  })
}

// 动态路由遍历，验证是否具备权限
export function filterDynamicRoutes(routes) {
  const res = []
  routes.forEach(route => {
    if (route.permissions) {
      if (auth.hasPermiOr(route.permissions)) {
        res.push(route)
      }
    } else if (route.roles) {
      if (auth.hasRoleOr(route.roles)) {
        res.push(route)
      }
    } else {
      res.push(route)
    }
  })
  return res
}

/**
 * 格式化树形结构数据 生成 vue-router 层级路由表
 *
 * @param routerMap
 * @param parent
 * @param routers
 * @returns {*}
 */
export const generator = (routerMap, parent, routers) => {
  const names = parent ? parent.meta.names : []
  return routerMap.map(item => {
    // 适配ruoyi一级菜单
    if (item.path === '/' && item.children && item.children.length === 1) {
      item = item.children[0]
      item.children = undefined
    }

    const { title, show, hideChildren, hiddenHeaderContent, hidden, icon, noCache } = item.meta || {}
    if (item.isFrame === 0) {
      item.target = '_blank'
    }
    const name = item.name || item.key || ''
    const isRouter = item.component && item.component !== 'Layout' && item.component !== 'ParentView'
    const currentRouter = {
      // 如果路由设置了 path，则作为默认 path，否则 路由地址 动态拼接生成如 /dashboard/workplace
      path: item.path || `${parent && parent.path || ''}/${item.path}`,
      // 路由名称，建议唯一
      name: name,
      // 该路由对应页面的 组件(动态加载)
      component: (constantRouterComponents[item.component || item.key]) || (() => import(`@/views/${item.component}`)),
      hidden: item.hidden,
      // meta: 页面标题, 菜单图标, 页面权限(供指令权限用，可去掉)
      meta: {
        title: title,
        icon: allIcon[icon + 'Icon'] || icon,
        hiddenHeaderContent: hiddenHeaderContent,
        // 目前只能通过判断path的http链接来判断是否外链，适配若依
        target: validURL(item.path) ? '_blank' : '',
        permission: item.name,
        keepAlive: noCache === undefined ? false : !noCache,
        hidden: hidden,
        // 因菜单路由分离，通过此names确定菜单树的展开
        names: names.concat([name]),
      },
      redirect: item.redirect,
    }
    // 是否设置了隐藏菜单
    if (show === false) {
      currentRouter.hidden = true
    }
    // 适配若依，若依为缩写路径，而antdv-pro的pro-layout要求每个路径需为全路径
    if (!constantRouterComponents[item.component || item.key]) {
      // currentRouter.path = `${parent && parent.path !== '/' && parent.path || ''}/${item.path}`
      currentRouter.path = `${parent && parent.path !== '/' && parent.path + '/' || ''}${item.path}`
    }
    // 是否设置了隐藏子菜单
    if (hideChildren) {
      currentRouter.hideChildrenInMenu = true
    }
    // const names = parent.names
    const router = {
      path: currentRouter.path,
      // 路由名称，建议唯一
      name: currentRouter.name,
      // 该路由对应页面的 组件(动态加载)
      component: currentRouter.component,
      hidden: currentRouter.hidden,
      // meta: 页面标题, 菜单图标, 页面权限(供指令权限用，可去掉)
      meta: currentRouter.meta,
      redirect: currentRouter.redirect,
    }
    if (router.component && isRouter) {
      routers.push(router)
    }
    // 是否有子菜单，并递归处理，并将父path传入
    if (item.children && item.children.length > 0) {
      // Recursion
      currentRouter.children = generator(item.children, currentRouter, routers)
    }
    return currentRouter
  })
}
